export const INSERTION_MARKER = '\u0001';
